/* global mapboxgl */
import React from 'react'
import {onMapboxReady} from 'lib/mapboxUtils'

const toHTML = iconSpec => {
  const img = document.createElement('img')
  img.src = iconSpec.iconUrl
  img.setAttribute('width', iconSpec.iconSize[0])
  img.setAttribute('height', iconSpec.iconSize[1])
  img.style.cssText = `z-index: ${iconSpec.zIndex === undefined ? 1 : iconSpec.zIndex}`
  return img
}

export class MapboxMarker extends React.PureComponent {
  componentDidMount () {
    const {mapInstance} = this.props
    onMapboxReady(mapInstance, this.addToMap)
  }

  componentDidUpdate () {
    const {mapInstance, position} = this.props
    onMapboxReady(mapInstance, () => {
      this._marker.setLngLat(position)
    })
  }

  componentWillUnmount () {
    const {mapInstance} = this.props
    onMapboxReady(mapInstance, () => {
      if (this._element) {
        this._element.removeEventListener('click', this.onClick)
        this._element.removeEventListener('mouseover', this.onMouseOver)
        this._element.removeEventListener('mouseout', this.onMouseOut)
      }
      this._marker && this._marker.remove()
    })
  }

  addToMap = () => {
    const {mapInstance, position, icon} = this.props
    const element = toHTML(icon)
    this._element = element
    this._marker = new mapboxgl.Marker({
      element,
      anchor: 'top-left',
      offset: [-icon.iconAnchor[0], -icon.iconAnchor[1]]
    }).setLngLat(position).addTo(mapInstance)
    element.addEventListener('click', this.onClick)
    element.addEventListener('mouseover', this.onMouseOver)
    element.addEventListener('mouseout', this.onMouseOut)
  }

  onClick = (e) => {
    e.stopPropagation() // prevent marker clicks from triggering map clicks
    this.props.onClick && this.props.onClick(e)
  }

  onMouseOver = (e) => {
    this.props.onMouseOver && this.props.onMouseOver(e)
  }

  onMouseOut = (e) => {
    this.props.onMouseOut && this.props.onMouseOut(e)
  }

  render () {
    return (
      null
    )
  }
}
